import { render, staticRenderFns } from "./addsavings.vue?vue&type=template&id=7b28140f&"
import script from "./addsavings.vue?vue&type=script&lang=js&"
export * from "./addsavings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports